import React, { createContext, useState, useEffect, useContext } from 'react';
import { LoginContext } from './loginContext';

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const { user } = useContext(LoginContext);

  const [categorias, setCategorias] = useState([]);
  const [tipoPagos, setTipoPagos] = useState([]);
  const [estadoPedidos, setEstadoPedidos] = useState([]);
  const [criteriosReemplazo, setCriteriosReemplazo] = useState([]);
  const [tipoFraccionamientos, setTipoFraccionamientos] = useState([]);
  const [loadingGlobal, setLoadingGlobal] = useState(true);

  const fetchCategorias = async () => {
    try {
      const headers = user?.token ? { Authorization: `Bearer ${user.token}` } : {};
      const res = await fetch(`${process.env.REACT_APP_API_URL}/categorias`, { headers });
      if (!res.ok) throw new Error('Error al obtener categorías');
      const data = await res.json();
      setCategorias(data);
    } catch (error) {
      console.error('Error al refrescar categorías:', error);
    }
  };

  const fetchAllData = async () => {
    try {
      const headers = user?.token ? { Authorization: `Bearer ${user.token}` } : {};

      const [
        resCategorias,
        resTipoPagos,
        resEstadoPedidos,
        resCriterios,
        resTipoFraccionamientos
      ] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_URL}/categorias`, { headers }),
        fetch(`${process.env.REACT_APP_API_URL}/tipo-pago`, { headers }),
        fetch(`${process.env.REACT_APP_API_URL}/estado-pedido`, { headers }),
        fetch(`${process.env.REACT_APP_API_URL}/criterios-reemplazo`, { headers }),
        fetch(`${process.env.REACT_APP_API_URL}/tipo-fraccionamiento`, { headers }),
      ]);

      if (
        !resCategorias.ok ||
        !resTipoPagos.ok ||
        !resEstadoPedidos.ok ||
        !resCriterios.ok ||
        !resTipoFraccionamientos.ok
      ) {
        throw new Error('Alguna solicitud falló');
      }

      const [
        dataCategorias,
        dataTipoPagos,
        dataEstadoPedidos,
        dataCriterios,
        dataTipoFraccionamientos
      ] = await Promise.all([
        resCategorias.json(),
        resTipoPagos.json(),
        resEstadoPedidos.json(),
        resCriterios.json(),
        resTipoFraccionamientos.json()
      ]);

      setCategorias(dataCategorias);
      setTipoPagos(dataTipoPagos.data);
      setEstadoPedidos(dataEstadoPedidos.data);
      setCriteriosReemplazo(dataCriterios);
      setTipoFraccionamientos(dataTipoFraccionamientos);
    } catch (error) {
      console.error('Error al cargar datos globales:', error);
    } finally {
      setLoadingGlobal(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  return (
    <GlobalContext.Provider
      value={{
        categorias,
        tipoPagos,
        estadoPedidos,
        criteriosReemplazo,
        tipoFraccionamientos,
        loadingGlobal,
        refreshCategorias: fetchCategorias,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};